import { render, staticRenderFns } from "./DashboardMobile.vue?vue&type=template&id=2b4ff4fd&"
import script from "./DashboardMobile.vue?vue&type=script&lang=js&"
export * from "./DashboardMobile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMobile.vue?vue&type=style&index=0&id=2b4ff4fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports